import GameConfig from "./core/data/GameConfig";
import { MissionData } from "./game/LTGame";
import SaveData, { MissionProgress } from "./SaveData";

export default abstract class PlayerData {
	public static Instance: PlayerData;
	protected _isLoaded: boolean;
	public abstract get saveData(): SaveData;
	public abstract get onLoaded(): () => void;
	public abstract set onLoaded(f: () => void);
	abstract load(): void;
	abstract save(): void;
	abstract reset(): void;
	public isLoaded(): boolean {
		return this._isLoaded;
	}

	static getItemValue(key: string) {
		const level = PlayerData.Instance.saveData.items[key];
		const val = GameConfig.get<any>("items")[key].values[level];
		return val;
	}

	static incrementMission(type: string, amt: number): void {
		const saveData = PlayerData.Instance.saveData;
		const mission = saveData.missions.find(m => m.type == type) as MissionProgress;
		if (mission) mission.progress += amt;
	}

	/**
	 * 
	 * @param progress : Previous mission progress from gamescene
	 */
	static resetMissionProgress(progress: number[]): void{
		const saveData = PlayerData.Instance.saveData;
		for (let i = 0; i < saveData.missions.length; i++) {
			const mission = saveData.missions[i];
			mission.progress = progress[i];
		}
	}

	static setMissionProgress(type: string, amt: number): void {
		const saveData = PlayerData.Instance.saveData;
		const mission = saveData.missions.find(m => m.type == type) as MissionProgress;
		if (mission) mission.progress = amt;
	}

	static getMissionProgress(type: string): number {
		const saveData = PlayerData.Instance.saveData;
		const mission = saveData.missions.find(m => m.type == type) as MissionProgress;
		if (mission) return mission.progress;
		else return 0;
	}

	static progressMissions(saveData: SaveData): boolean {
		let completedMission = false;
		const missionDatas = GameConfig.get("missions") as MissionData[];
		for (let i = 0; i < saveData.missions.length; i++) {
			const mission = saveData.missions[i];
			if (mission && mission.progress >= mission.goal) {
				saveData.missions[i] = null;
				saveData.missionsCompleteForCharacterUnlock++;
				saveData.completedMissions[mission.type]++;

				const missionData = missionDatas.find(m => m.type == mission.type);
				if (saveData.completedMissions[mission.type] >= missionData.goals.length) {
					// console.log("Resetting " + mission.type, saveData.completedMissions[mission.type]);
					saveData.completedMissions[mission.type] = missionData.goals.length - 3;
					// console.log("Reset " + mission.type, saveData.completedMissions[mission.type]);
				}
				saveData.coins += mission.reward;
				completedMission = true;
			}
		}
		return completedMission;
	}

	static getMissionsComplete(saveData: SaveData): MissionProgress[] {
		let completedMissions: MissionProgress[] = [];
		for (let i = 0; i < saveData.missions.length; i++) {
			const mission = saveData.missions[i];
			if (mission && mission.progress >= mission.goal && !mission.completed) {
				completedMissions.push(mission);
				mission.completed = true;
			}
		}
		return completedMissions;
	}
}